var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wf-model"},[_c('div',{staticClass:"wf-content"},[_c('div',{staticClass:"wf-content-title"},[_vm._v("文房装备")]),_vm._v(" "),_c('div',{staticClass:"wf-content-vice"},[_vm._v("课前你需要准备好")]),_vm._v(" "),_c('div',{staticClass:"wf-content-zq",on:{"click":function($event){return _vm.clickItem({
          title: '买单品',
          content: ['<br><br><br>'],
          qrcode: _vm.dataSource.wfShopQrcode,
          shop: true
        })}}},[_vm._v("\n      买单品\n    ")]),_vm._v(" "),_c('Swiper',{attrs:{"duration":2000,"dataSource":_vm.dataSource.wf},on:{"clickItem":_vm.clickItem}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }